import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Search } from 'lucide-react';
import { API, OUTCOMES } from './api';
import ResponseUpload from './ResponseUpload';

const BureauRow = ({ rec, bureau, onSet }) => (
  <div className="flex items-center gap-1" data-testid={`outcome-${rec.id}-${bureau}`}>
    <span className="w-20 text-[10px] uppercase text-zinc-500">{bureau}</span>
    {OUTCOMES.map(([k, label, tone]) => {
      const on = rec.outcomes?.[bureau] === k;
      return (
        <button key={k} type="button" onClick={() => onSet(rec, bureau, on ? null : k)} data-testid={`outcome-${rec.id}-${bureau}-${k}`}
          className={`rounded px-1.5 py-0.5 text-[10px] font-semibold transition-colors ${on ? tone : 'border border-zinc-700 text-zinc-400 hover:text-white'}`}>{label}</button>
      );
    })}
  </div>
);

// Every letter we've generated, with one-click results per bureau.
export default function OutcomeRecords() {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState(null);
  const load = useCallback(() => axios.get(`${API}/records`, { params: { q } }).then((r) => setRows(r.data)).catch(() => setRows([])), [q]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);
  const onSet = async (rec, bureau, outcome) => {
    setRows((rs) => rs.map((r) => (r.id === rec.id ? { ...r, outcomes: { ...r.outcomes, [bureau]: outcome } } : r)));
    try { await axios.post(`${API}/records/${rec.id}/outcome`, { bureau, outcome }); } catch (e) { toast.error('Could not save'); load(); }
  };
  return (
    <div className="space-y-3" data-testid="outcome-records">
      <ResponseUpload onDone={load} />
      <div className="flex items-center gap-2 rounded-md border border-zinc-700 bg-zinc-950 px-2">
        <Search className="w-3.5 h-3.5 text-zinc-500" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search client or account" data-testid="records-search"
          className="w-full bg-transparent py-1.5 text-xs text-white outline-none" />
      </div>
      {rows && !rows.length && <p className="text-xs text-zinc-500" data-testid="records-empty">No letters yet. Letters made with "Generate all letters" or saved to a client show up here.</p>}
      {(rows || []).map((r) => (
        <div key={r.id} className="rounded-lg border border-zinc-800 bg-zinc-900/60 p-2.5 space-y-1" data-testid={`record-${r.id}`}>
          <p className="text-xs text-white"><b>{r.client_name}</b> · {r.account}
            <span className="ml-1 text-zinc-500">· {r.angle} · {new Date(r.created_at).toLocaleDateString()}{r.variation_id ? ' · approved variation' : ''}</span></p>
          {(r.bureaus || []).map((b) => <BureauRow key={b} rec={r} bureau={b} onSet={onSet} />)}
        </div>
      ))}
    </div>
  );
}
